import { render } from "./normscaletable.vue?vue&type=template&id=3f275a2e&scoped=true"
import script from "./normscaletable.vue?vue&type=script&lang=js"
export * from "./normscaletable.vue?vue&type=script&lang=js"

import "./normscaletable.vue?vue&type=style&index=0&id=3f275a2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f275a2e"]])

export default __exports__